import React, { useState } from 'react';
import Content from '../../../layout/content/Content';
import Head from '../../../layout/head/Head';
import { Block, BlockHead, BlockHeadContent, BlockTitle } from '../../../components/Component';
import CardTabs from '../../components/cards/CardTabs';
import MainAllocationsData from './data/MainAllocationsData';
import AgencyAllocationsData from './data/AgencyAllocationsData';

const BudgetAllocationDetails = ({ tenant_info, user_info }) => {

 const [activeCardTab, setActiveCardTab] = useState("Main Info");

 // Card Tabs
 const tabs = [
  {
   tabName: "Main Info"
  },
  {
   tabName: "Allocations"
  },
  {
   tabName: "History"
  }
 ];


 return (
  <>
   <Head title={tenant_info?.name ? `${tenant_info.name} Budget Allocation Details` : "Budget Allocation Details"} />
   <Content>
    <BlockHead size="sm">
     <BlockHeadContent>
      <BlockTitle page> Budget Allocation Details</BlockTitle>
     </BlockHeadContent>
    </BlockHead>
    <Block>
     <CardTabs cardTabs={tabs} activeCardTab={activeCardTab} setActiveCardTab={setActiveCardTab} />
    </Block>
    {
     activeCardTab === "Main Info" && (
      <MainAllocationsData tenant_info={tenant_info} user_info={user_info} />
     )
    }
    {
     activeCardTab === "Allocations" && (
      <AgencyAllocationsData tenant_info={tenant_info} user_info={user_info} />
     )
    }
   </Content>
  </>
 );
};

export default BudgetAllocationDetails;